<template>

    <div>
        <div v-if="showFeedback">

            <transition name="animationoverlay">

                <div v-show="showOverlay" :class="{ 'feedback__container-modal': computedFeedbackContainerModal }" class="feedback__container" @click.self="quietClose">

                    <transition name="animationmodal">

                        <div v-show="showBloc" :class="{ 'feedback__bloc-modal': computedFeedbackContainerModal }" class="feedback__bloc">

                            <div class="feedback__bloc-transition">

                                <div ref="bloc-transition-children" :style="{ visibility: transitionVisibility }" class="feedback__bloc-transition">

                                    <mq-layout v-touch:swipe.bottom="quietClose" :mq="['sm', 'md']" class="feedback__handle-container">

                                        <div class="feedback__handle"></div>

                                    </mq-layout>

                                    <img v-if="computedFeedbackContainerModal && step === 4" class="feedback__bloc-cancel-img" src="/img/icons/cancel-grey.svg" @click="quietClose">


                                    <!--STEP 1-->
                                    <template v-if="step === 1">

                                        <h1 class="cf-headline">{{ $t('feedback_rating_title') }}</h1>

                                        <div class="feedback__step-1__btn_container">

                                            <div class="btn btn-grey feedback__step-1__btn" @click="btnSad">
                                                <span class="feedback__step-1__text">{{ $t('feedback_rating_cta_no') }}</span>
                                                <img class="feedback__step-1__img" src="/img/icons/emoji-sad.svg">
                                            </div>

                                            <div class="btn btn-grey feedback__step-1__btn" @click="btnHappy">
                                                <span class="feedback__step-1__text">{{ $t('feedback_rating_cta_yes') }}</span>
                                                <img class="feedback__step-1__img" src="/img/icons/emoji-happy.svg">
                                            </div>

                                        </div>

                                        <div v-if="$mq === 'lg'" class="btn btn-big btn-white feedback__step-1__btn-close" @click="close">
                                            Plus tard
                                        </div>

                                    </template>


                                    <!--STEP 2-->
                                    <template v-if="step === 2">

                                        <h1 class="cf-headline">{{ $t('feedback_happy_title') }}</h1>

                                        <p class="feedback__step-2__text">{{ $t('feedback_happy_text') }}</p>

                                        <button class="btn btn-green btn-big btn-new feedback__step-2__btn" @click="rate">{{ $t('feedback_happy_cta') }}</button>

                                        <div v-if="$mq === 'lg'" class="btn btn-big btn-white feedback__step-2__btn-close" @click="close">
                                            {{ $t('feedback_sad_cta_no') }}
                                        </div>

                                    </template>


                                    <!--STEP 3-->
                                    <template v-if="step === 3">

                                        <h1 class="cf-headline">{{ $t('feedback_sad_title') }}</h1>

                                        <p class="feedback__step-3__text">{{ $t('feedback_sad_text') }}</p>

                                        <button class="btn btn-blue btn-big btn-new feedback__step-3__btn" @click="goStep(4)">{{ $t('feedback_sad_cta_yes') }}</button>

                                        <button class="btn btn-big btn-new feedback__step-3__btn feedback__step-3__btn-2" @click="close">{{ $t('feedback_sad_cta_no') }}</button>

                                    </template>


                                    <!--STEP 4 && 5-->

                                    <feedback-end v-if="$mq !== 'lg'"
                                                  :improvements="improvements"
                                                  :requesting="requesting"
                                                  :step="step"
                                                  @close="close"
                                                  @submitForm="submitForm"
                                                  @updateMessage="updateMessage"
                                    ></feedback-end>

                                </div>

                            </div>

                        </div>

                    </transition>

                </div>

            </transition>

        </div>

        <modal :show="showModal && $mq === 'lg'" @closeModal="close">
            <!--STEP 4 && 5-->
            <feedback-end :improvements="improvements"
                          :requesting="requesting"
                          :step="step"
                          @close="close"
                          @submitForm="submitForm"
                          @updateMessage="updateMessage"
            ></feedback-end>
        </modal>

    </div>

</template>

<script>

import Api from '../../api'

import UserAgent from '@/modules/userAgent'
import Tag from '@/modules/tag'

import FeedbackEnd from '@/components/Feedback/FeedbackEnd'
import Modal from '@/components/modal/Modal'

export default {

    name: 'feedback',

    components: {FeedbackEnd, Modal},

    props: {

        feedbackGoodPosition: {
            type: Boolean,
            default: false
        },

        isList: {
            type: Boolean,
            default: true
        }
    },

    watch: {

        step: function (step) {

            switch (step) {
                case 1:
                    Tag.pageViewAmplitude(this, 'feedback_rating')
                    break
                case 2:
                    Tag.pageViewAmplitude(this, 'feedback_happy')
                    break
                case 3:
                    Tag.pageViewAmplitude(this, 'feedback_sad')
                    break
                case 4:
                    Tag.pageViewAmplitude(this, 'feedback_sad_survey')
                    break
            }

        },

        showFeedback: function (newValue) {

            if (newValue && this.step <= 1) {

                this.goStep(1)

            }
        }
    },

    computed: {

        computedFeedbackContainerModal: function () {

            return this.$mq === 'lg' && this.step > 3

        },

        showFeedback() {

            return this.feedbackGoodPosition && !this.isList && !this.hasCommented && !(this.$mq === 'lg' && (this.step === 4 || this.step === 5))

        }

    },

    //STEP 1: question
    //STEP 2: yes
    //STEP 3: no
    //STEP 4: form
    //STEP 5: thanks

    data() {
        return {
            step: 0,
            improvements: [],
            transitionDuration: 10,
            transitionVisibility: 'visible',
            showOverlay: false,
            showBloc: false,
            mood: '',
            message: '',
            alreadySendMood: false,
            hasCommented: true,
            showModal: false,
            requesting: false
        }
    },

    mounted() {

        this.goStep(1)

        Api.feedback.has()
            .then(data => {
                this.hasCommented = data.hasCommented
            })
            .catch(() => {
            })

        this.improvements = [
            {active: false, name: this.$t('feedback_sad_survey_cta_newsletters'), key: 'newsletters'},
            {active: false, name: this.$t('feedback_sad_survey_cta_scan'), key: 'scan'},
            {active: false, name: this.$t('feedback_sad_survey_cta_deletion'), key: 'deletion'},
            {active: false, name: this.$t('feedback_sad_survey_cta_log'), key: 'log'}
        ]

    },

    methods: {

        btnSad() {

            this.mood = 'sad'
            this.submit()
            this.alreadySendMood = true
            this.goStep(3)
        },

        btnHappy() {

            this.mood = 'happy'
            this.submit()
            this.alreadySendMood = true
            Tag.clickAmplitude(this, 'feedback_happy')
            this.goStep(2)
        },

        goStep(step) {

            if (step === 1) {

                this.showOverlay = true
                this.showBloc = true

            }

            this.step = step

            if (this.$mq === 'lg' && (step === 4 || step === 5)) {

                this.showModal = true

            } else if (this.$mq === 'lg') {

                this.showModal = false

            }

        },

        rate() {

            window.open(this.$t('feedback_trustpilot_url'), '_blank', 'rel="noopener,noreferrer,nofollow"')

            this.close()
        },

        close(quiet) {

            if (!this.alreadySendMood) {
                this.mood = 'skip'
                this.submit()
            }
            this.showModal = false
            this.showBloc = false
            const self = this
            setTimeout(function () {
                self.showOverlay = false
            }, 100)

            if (!quiet) {

                this.$emit('close')

            }
        },

        quietClose() {

            this.close(true)

        },

        submitForm() {

            this.requesting = true
            this.submit()
                .then(() => {
                    this.goStep(5)
                })
                .catch(() => {
                    this.requesting = false
                })

        },

        updateMessage(message) {
            this.message = message
        },

        submit() {

            return new Promise((resolve, reject) => {

                const platform = UserAgent.getDevice()

                const mood = this.mood

                const badges = this.improvements.filter(badge => badge.active).map(badge => badge.key)

                const message = this.message

                Api.feedback.update(platform, mood, badges, message)
                    .then(() => {
                        resolve()
                    })
                    .catch(error => {

                        if (this.step === 4) {
                            reject(error)
                        } else {
                            resolve()
                        }
                    })
            })
        }
    }

}
</script>

<style lang="scss" scoped>


.btn-new {
    min-width: 160px;
    padding-left: 24px;
    padding-right: 24px;
    width: auto;
}

.feedback {

    &__container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.6);
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    &__container-modal {
        align-items: center;
    }

    &__bloc {
        width: 100%;
        background-color: $white;
        box-shadow: 0 14px 23px 0 rgba(0, 0, 0, 0.1);
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
        padding: 0 24px 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @media screen and (min-width: $above-tablet-length) {
            width: 480px;
            padding: 32px 32px 24px;
        }
    }

    &__bloc-modal {
        border-radius: 8px;
        padding: 40px;
        position: relative;
    }

    &__bloc-transition {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    &__handle-container {
        height: 46px;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    &__handle {
        width: 40px;
        height: 6px;
        border-radius: 3px;
        background-color: $silver;
        margin-top: 24px;
    }

    &__bloc-cancel-img {
        position: absolute;
        top: 16px;
        right: 16px;
        width: 24px;
        object-fit: contain;
        opacity: 0.3;
    }

    &__step-1 {

        &__btn_container {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 16px;
            @media screen and (min-width: $above-tablet-length) {
                justify-content: center;
            }
        }

        &__btn {
            margin: 0 8px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 0 16px;
            @media screen and (min-width: $above-tablet-length) {
                width: auto;
            }
        }

        &__text {
            font-size: 13px;
            font-weight: bold;
            line-height: 1.38;
        }

        &__img {
            width: 24px;
            object-fit: contain;
            @media screen and (min-width: $above-tablet-length) {
                margin-left: 8px;
            }
        }

        &__btn-close {
            @media screen and (min-width: $above-tablet-length) {
                color: $stone;
                width: auto;
                padding: 0 16px;
                min-width: 160px;
                margin-top: 16px;
                font-size: 17px;
                font-weight: bold;
            }
        }
    }

    &__step-2 {

        &__text {
            margin-top: 16px;
            font-size: 14px;
            line-height: 1.29;
        }

        &__btn {
            max-width: 268px;
            margin-top: 16px;
        }

        &__btn-close {
            @media screen and (min-width: $above-tablet-length) {
                color: $stone;
                width: auto;
                padding: 0 16px;
                min-width: 160px;
                margin-top: 8px;
                font-size: 17px;
                font-weight: bold;
            }
        }
    }

    &__step-3 {

        &__text {
            font-size: 14px;
            line-height: 1.29;
            margin: 16px 0 8px;
            @media screen and (min-width: $above-tablet-length) {
                margin: 16px 0 0;
            }
        }

        &__btn {
            margin-top: 16px;
        }

        &__btn-2 {
            color: $stone;
            height: 40px;
            margin-top: 8px;
        }

        &__btn-2:hover {
            background-color: white;
        }
    }

    &__step-4 {


        &__container {
            margin-top: 4px;
            width: 100%;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        &__badge {
            margin: 8px 4px 0;
            padding: 8px 12px;
            border-radius: 24px;
            background-color: $timberwolf;
            font-size: 14px;
            line-height: 1.29;
        }

        &__badge-active {
            background-color: $blue;
            color: $white;
        }

        &__divider {
            width: 100%;
            margin: 24px 0 16px;
            height: 1px;
            border-radius: 2px;
            background-color: $timberwolf;
        }

        &__text-area {
            resize: none;
            margin-top: 16px;
            width: 100%;
            height: 142px;
            background-color: $timberwolf;
            border-radius: 6px;
            border: none;
            padding: 8px 12px;

            font-size: 14px;
            line-height: 1.29;
        }

        &__text-area:focus {
            -moz-appearance: none;
            outline: 0px none transparent;
        }

        &__btn {
            background-color: $silver;
            font-size: 17px;
            font-weight: bold;
            color: $stone;
            margin-top: 16px;
            cursor: not-allowed;
        }

        &__btn-active {
            background-color: $green;
            color: $white;
            cursor: pointer;
        }
    }

    &__step-5 {

        &__text {
            font-size: 14px;
            line-height: 1.29;
            margin-top: 16px;
        }

        &__btn {
            font-size: 17px;
            font-weight: bold;
            margin-top: 16px;
        }
    }
}

/*animation*/


.animationmodal-enter-active {
    transition: 0.6s cubic-bezier(0.23, 1, 0.32, 1);
}

.animationmodal-enter {
    transform: translate(0, 20%);
    opacity: 0;
}

.animationmodal-leave-active {
    transition: 0.2s cubic-bezier(0.755, 0.05, 0.855, 0.06);
}

.animationmodal-leave-to {
    /*transform: translate(0, 50%);*/
    opacity: 0;
}


.animationoverlay-enter-active {
    opacity: 0;
    animation: keyframeoverlayenter 500ms ease-in-out 0ms 1 normal forwards;
}

.animationoverlay-leave-active {
    animation: keyframeoverlayleave 200ms ease-in-out 0ms 1 normal forwards;
}

@keyframes keyframeoverlayenter {

    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes keyframeoverlayleave {

    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

</style>
